import { render, staticRenderFns } from "./ArtifactStatsCard.vue?vue&type=template&id=08a087ee&scoped=true&"
import script from "./ArtifactStatsCard.vue?vue&type=script&lang=js&"
export * from "./ArtifactStatsCard.vue?vue&type=script&lang=js&"
import style0 from "./ArtifactStatsCard.vue?vue&type=style&index=0&id=08a087ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a087ee",
  null
  
)

export default component.exports